// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_kh-0";
export var discountCodeInput = "_kh-1";